import { render, staticRenderFns } from "./wenzhen.vue?vue&type=template&id=009757e0&scoped=true&"
import script from "./wenzhen.vue?vue&type=script&lang=ts&"
export * from "./wenzhen.vue?vue&type=script&lang=ts&"
import style0 from "./wenzhen.vue?vue&type=style&index=0&id=009757e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009757e0",
  null
  
)

export default component.exports